/*jshint esversion: 9 */
import React, { Component }  from 'react';
// import clsx from  'clsx';

import PropTypes    from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';

// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Divider from '@material-ui/core/Divider';

import IconButton from '@material-ui/core/IconButton';

import store from '../../../../components/stores/Store';
import { relocateOfficeConfirm, financeOfficeConfirm, getImageUrls, returnOrder, cancelOrder } from '../../../../db/TradeRequestHandler';
import { getIfFuncAuthorized } from '../../../../utils/CheckSomething';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { imgHostIp } from '../../../../config/ips';

const styles = {
  root: {
    width: '100%',
  },
  paper: {
    overflowX: 'scroll' ,
    overflowY: 'scroll' 
  },
  tableContainer: {
    // maxHeight: '450px', // todo
    // maxWidth: '100%', // todo
  },
  table: {
    // minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  TableCell: {
    borderRight: 'solid', 
    borderRightColor: '#eee'
  },
  imageList: {
    width: 500,
    height: 'auto',
  },
};
// TableOfRoomManagement
class TableOfRoomManagementInner extends Component {
  constructor() {
    super();
    store.setOrderByOfTableConfig("orderNumber");
    store.setOrderOfTableConfig("desc");
    this.state = {
      login: true,
      selected:[],
      innerWidth: 100,
      innerHeight: 100,

      attachmentDialogOpen: false,
      imgsInfo: [],

      bigImageDialogOpen: false,
      bigImageUrl: '',
      tableContainerHeight: '500px',
      confirmDialogOpen: false,
      confirmShortTxt: '',
      confirmLongTxt: '',
      doConfirmFunc: function () { },
      confirmId: '',
    };
    this.sampleMehtod = this.sampleMehtod.bind(this);
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.sortHandler = this.sortHandler.bind(this);
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.returnOrder = this.returnOrder.bind(this);
    this.cancelOrder = this.cancelOrder.bind(this);
    this.relocateOfficeConfirm = this.relocateOfficeConfirm.bind(this);
    this.financeOfficeConfirm = this.financeOfficeConfirm.bind(this);
    this.showAttachment = this.showAttachment.bind(this);
    this.closeAttachmentDialog = this.closeAttachmentDialog.bind(this);


    this.openBigImageDialog = this.openBigImageDialog.bind(this);
    this.closeBigImageDialog = this.closeBigImageDialog.bind(this);
    this.calcSize = this.calcSize.bind(this);

    this.closeConfirmLineDialog = this.closeConfirmLineDialog.bind(this);
    this.openConfirmLineDialog = this.openConfirmLineDialog.bind(this);
  }

  async componentDidMount() {
    this.setState({
      innerWidth:  window.innerWidth,
      innerHeight: window.innerHeight,
    });
    this.calcSize();
  }
  componentWillUnmount() {}

  sampleMehtod(e) {
    console.log(e);
  }
  isSelected (name) 
  {
    return this.state.selected.indexOf(name) !== -1;
  }


  calcSize() {
    // const innerWidth  = window.innerWidth;
    const innerHeight = window.innerHeight;
    this.setState({
      tableContainerHeight: `${innerHeight - 330}px`,
    });
  }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  handleSelectAllClick (event) {
    console.log(`----- event.target.checked: `, event.target.checked);
    if (event.target.checked) {
      const newSelecteds = store.table.map((n) => n.name);
      this.setState({selected: newSelecteds});
      return;
    }
    this.setState({selected: []});
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === 'desc' ?
      (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => - 1 * this.descendingComparator(a, b, orderBy);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      }
    });
  }

  handleChangePage(event, newPage) {
    console.log(`----- handleChangePage-newPage: `, newPage);
    store.setCurrentPageOfTableConfig(newPage);
    store.search();
  }

  handleChangeRowsPerPage(event) {
    store.setRowsPerPageOfTableConfig(parseInt(event.target.value, 10));
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  sortHandler(event, header) {
    if (!header.sortable) return;
    const orderBy = header.id;
    const order   = (orderBy === store.tableConfig.orderBy && store.tableConfig.order === 'asc') ? 'desc' : 'asc';
    store.setOrderOfTableConfig(order);
    store.setOrderByOfTableConfig(orderBy);
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  async returnOrder() { // 退回销售
    console.log(`----- send req of 退回销售-id: `, this.state.confirmId);
    const rst = await returnOrder({ID: this.state.confirmId});
    console.log(`----- rst of 退回销售: `, rst);
    if (rst.code === 'error' ) {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '系统错误');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '退回销售成功');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      this.closeConfirmLineDialog();
      store.search();
      return true;
    }
  }

  async cancelOrder() { // 取消订单
    console.log(`----- send req of 取消订单-id: `, this.state.confirmId);
    const rst = await cancelOrder({ID: this.state.confirmId});
    console.log(`----- rst of 取消订单: `, rst);
    if (rst.code === 'error' ) {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '系统错误');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '取消订单成功，请检查房票余额。');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      this.closeConfirmLineDialog();
      store.search();
      return true;
    }
  }

  async relocateOfficeConfirm() { // 动迁办确认
    console.log(`----- send req of 动迁办确认`);
    const rst = await relocateOfficeConfirm({ID: this.state.confirmId});
    console.log(`----- rst of 动迁办确认: `, rst);
    if (rst.code === 'error' ) {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '系统错误');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      store.openMessageDialogOpen(rst.msg || '动迁办确认成功');
      console.log(`----- store.messageDialogInfo.open:`, store.messageDialogInfo.open);
      this.closeConfirmLineDialog();
      store.search();
      return true;
    }
  }

  async financeOfficeConfirm() { // 财资审核
    console.log(`----- send req of 财资审核`);
    const rst = await financeOfficeConfirm({ID: this.state.confirmId});
    console.log(`----- rst of 财资审核: `, rst);
    if (rst.code === 'error' ) {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || '财资审核成功');
      this.closeConfirmLineDialog();
      store.search();
      return true;
    }
  }

  async showAttachment (e, row) {
    const rst = await getImageUrls({ relateId: row.ID });
    if (rst.code === 'error' || !rst.data) {
      store.openMessageDialogOpen(rst.msg || '附件查询错误');
      return true;
    }
    // 数据按照 TYPE, NUMBER, ID 递增排序
    const imgsInfo = [];
    for (let index = 0; index < rst.data.length; index++) {
      const element = rst.data[index];
      imgsInfo.push({
        id: element.ID,
        title: element.title,
        url: `${imgHostIp}/${element.url}`,
        type: element.type,
        num: element.NUMBER,
        isdeleted: element.isdeleted,
      });
    }
    this.setState({
      attachmentDialogOpen: true,
      imgsInfo: imgsInfo,
    });
  }

  closeAttachmentDialog () {
    this.setState({
      attachmentDialogOpen: false,
      imgsInfo: [],
    });
  } 

  openBigImageDialog(url) {
    console.log(`----- openBigImageDialog-url: `, url);
    this.setState({
      bigImageDialogOpen: true,
      bigImageUrl: (url || '').replace('-thumb', ''), // 显示全尺寸整的图片
    });
  }

  closeBigImageDialog() {
    this.setState({
      bigImageDialogOpen: false,
      bigImageUrl: '',
    });
  }

  openConfirmLineDialog(confirmShortTxt, confirmLongTxt, doConfirmFunc, confirmId) {
    console.log(`----- openConfirmLineDialog-confirmId: `, confirmId);
    this.setState({
      confirmShortTxt,
      confirmLongTxt,
      confirmDialogOpen: true,
      doConfirmFunc: () => doConfirmFunc,
      confirmId,
    });
  }

  closeConfirmLineDialog() {
    this.setState({
      confirmShortTxt: '',
      confirmLongTxt: '',
      confirmDialogOpen: false,
      doConfirmFunc: function () { },
      confirmId: '',
    });
  }


  render() {
    const { classes } = this.props;
    const headCells = [
      { id: 'orderNumber', align: 'center',  disablePadding: true,   label: '订单号', sortable: true,},
      { id: 'subarea', align: 'center',  disablePadding: true,   label: '区域', sortable: true, },
      { id: 'transactionTime', align: 'center',  disablePadding: true,   label: '交易时间', sortable: true, },
      { id: 'entryTime', align: 'center',  disablePadding: true,   label: '入账时间', sortable: true, },
      { id: 'orderStatus', align: 'center',  disablePadding: true,   label: '订单状态', sortable: true, },
      { id: 'developerName', align: 'center',  disablePadding: true,   label: '开发商', sortable: true, },
      { id: 'housingResources', align: 'center',  disablePadding: true,   label: '房源', sortable: true, },
      { id: 'ticketHolder', align: 'center',  disablePadding: true,   label: '被搬迁户', sortable: true, },
      { id: 'buyer', align: 'center',  disablePadding: true,   label: '房票使用人', sortable: true, },
      { id: 'unitPrice', align: 'center',  disablePadding: true,   label: '房源单价', sortable: false, },
      { id: 'actualPrice', align: 'center',  disablePadding: true,   label: '实际单价', sortable: false, },
      { id: 'unitperPrice', align: 'center',  disablePadding: true,   label: '单价差额', sortable: false, },
      { id: 'transactionAmount', align: 'center',  disablePadding: true,   label: '交易金额', sortable: false, },
      { id: 'roomTicket', align: 'center',  disablePadding: true,   label: '房票支付', sortable: false, },
      { id: 'cashTransfer', align: 'center',  disablePadding: true,   label: '现金转账', sortable: false, },
      { id: 'paymentMethod', align: 'center',  disablePadding: true,   label: '支付方式', sortable: true, },
      { id: 'actions', align: 'center',  disablePadding: true,   label: '操作', sortable: false, },
    ];

    const emptyRows = Math.max(10 - store.table.length, 0);


    return (
      <div className={classes.root} >
        {/* <Paper className={classes.paper} style={{height: `${(this.state.innerHeight - 210)}px`, width: `${(this.state.innerWidth - 310)}px`}}> */}
        <Paper className={classes.paper}>
          <TableContainer style={{width: '100%', maxHeight: this.state.tableContainerHeight}}>
            <Table
              stickyHeader={true}
              className={classes.table}
              aria-labelledby="tableTitle"
              size='small'
              aria-label="enhanced table"
              id='TableOfOrder'
            >
              <TableHead style={{ position: 'sticky'}}>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding="none"
                      sortDirection={
                        store.tableConfig.orderBy === headCell.id 
                          ? store.tableConfig.order 
                          : false
                      }
                      className={classes.TableCell}
                    >
                      {headCell.sortable &&
                        <TableSortLabel
                          active={store.tableConfig.orderBy === headCell.id}
                          direction={
                            store.tableConfig.orderBy === headCell.id
                              ? store.tableConfig.order
                              : "asc"
                          }
                          onClick={event => this.sortHandler(event, headCell)}
                        >
                          {headCell.label}
                          {store.tableConfig.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {store.tableConfig.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      }
                      
                      {!headCell.sortable &&
                        <TableSortLabel hideSortIcon>
                          {headCell.label}
                        </TableSortLabel>
                      }
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.table, 
                  this.getComparator(
                    store.tableConfig.order,
                    store.tableConfig.orderBy
                    )
                  ).map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
  
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.ID}
                      >
                        <TableCell component="th" align="center" scope="row" padding="none" size="small" className={classes.TableCell}>
                          {row.orderNumber}
                        </TableCell>
                        <TableCell component="th" align="center" scope="row" padding="none" size="small" className={classes.TableCell}>
                          {row.subarea || ''}
                        </TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.transactionTime}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.entryTime}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>
                          {({'1': '未提交', '2': '已提交', '3': '已动迁审核', '4': '已财资确认', '9': '已拒绝'	})[row.orderStatus]}
                        </TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.developerName}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.housingResources}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.ticketHolder}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.buyer}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.unitPrice}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.actualPrice}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.unitperPrice}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.transactionAmount}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.roomTicket}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{row.cashTransfer}</TableCell>
                        <TableCell align="left" padding="none" size="small" className={classes.TableCell}>{['', '房票支付', '房票支付+现金转账'][row.paymentMethod]}</TableCell>
                        <TableCell align="center" style={{ width: '100px', paddingLeft:'0', paddingRight:'0' }}  size="small">
                          <ButtonGroup
                            variant="contained"
                            size="small"
                            aria-label="contained primary button group"
                            padding="none">
                            {/* <Button color="primary" size="small">修改todo</Button> */}
                            {(getIfFuncAuthorized('交易管理-交易记录管理-退回销售')) && (
                              <Button color="primary" size="small"
                                disabled={!(row.orderStatus === '2')}
                                onClick={e => this.openConfirmLineDialog('退回销售', '', this.returnOrder, row.ID)}>退回销售</Button>
                            )}
                            {(getIfFuncAuthorized('交易管理-交易记录管理-取消订单')) && (
                              <Button color="primary" size="small"
                                disabled={!(['1', '2'].includes(row.orderStatus))}
                                onClick={e => this.openConfirmLineDialog('取消订单', '订单将被删除。取消后请检查房票余额是否正确。', this.cancelOrder, row.ID)}>取消订单</Button>
                            )}
                            {(getIfFuncAuthorized('交易管理-交易记录管理-动迁办确认')) && ( 
                              <Button color="primary" size="small"
                                disabled={!(row.orderStatus === '2')}
                                onClick={e => this.openConfirmLineDialog('动迁办确认', '动迁办确认', this.relocateOfficeConfirm, row.ID)}>动迁办确认</Button>
                            )}
                            {(getIfFuncAuthorized('交易管理-交易记录管理-财资审核')) && ( 
                              <Button color="primary" size="small"
                                disabled={!(row.orderStatus === '3')}
                                onClick={e => this.openConfirmLineDialog('财资审核', '财资审核', this.financeOfficeConfirm, row.ID)}>财资审核</Button>
                            )}
                            {(getIfFuncAuthorized('交易管理-交易记录管理-查看附件')) && ( 
                              <Button color="primary" size="small"
                                onClick={e => this.showAttachment(e, row)}
                              >查看附件</Button>
                            )}
                            {/* <Button color="secondary" size="small">删除</Button> */}
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 135 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.tableCount}
            rowsPerPage={store.tableConfig.rowsPerPage}
            page={store.tableConfig.currentPage}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>



        {/* 查看附件 */}
        <Dialog aria-labelledby="form-dialog-title"
          open={this.state.attachmentDialogOpen}
          onClose={this.closeAttachmentDialog}>
          <DialogTitle id="form-dialog-title"  style={{textAlign: 'center'}}>查看附件</DialogTitle>
          <DialogContent>
            <div style={{marginTop: '0'}}>1.身份证</div>
            <ImageList className={classes.imageList}>
              {
                this.state.imgsInfo.map((item) => {
                  if (`${item.type}` !== '1') return null;
                  return (
                    <ImageListItem key={item.ID}
                      onClick={e => this.openBigImageDialog(item.url)}
                    >
                      <img src={item.url} alt={'' && 'item.title'} />
                    </ImageListItem>
                  );
                }
              )}
            </ImageList>
            <Divider style={{marginTop: '10px'}} />

            <div style={{marginTop: '30px'}}>2.户口本</div>
            <ImageList className={classes.imageList}>
              {
                this.state.imgsInfo.map((item) => {
                  if (`${item.type}` !== '2') return null;
                  return (
                    <ImageListItem key={item.ID}
                      onClick={e => this.openBigImageDialog(item.url)}
                    >
                      <img src={item.url} alt={'' && 'item.title'} />
                    </ImageListItem>
                  );
                }
              )}
            </ImageList>
            <Divider style={{marginTop: '10px'}} />

            <div style={{marginTop: '30px'}}>3.购房合同</div>
            <ImageList className={classes.imageList}>
              {
                this.state.imgsInfo.map((item) => {
                  if (`${item.type}` !== '3') return null;
                  return (
                    <ImageListItem key={item.ID}
                      onClick={e => this.openBigImageDialog(item.url)}
                    >
                      <img src={item.url} alt={'' && 'item.title'} />
                    </ImageListItem>
                  );
                }
              )}
            </ImageList>
            <Divider style={{marginTop: '10px'}} />

            <div style={{marginTop: '30px'}}>4.合照</div>
            <ImageList className={classes.imageList}>
              {
                this.state.imgsInfo.map((item) => {
                  if (`${item.type}` !== '4') return null;
                  return (
                    <ImageListItem key={item.ID}
                      onClick={e => this.openBigImageDialog(item.url)}
                    >
                      <img src={item.url} alt={'' && 'item.title'} />
                    </ImageListItem>
                  );
                }
              )}
            </ImageList>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeAttachmentDialog} color="primary" variant="contained"
              aria-label="contained primary button group">
              关闭
            </Button>
          </DialogActions>
        </Dialog>

        {/* 大图显示 */}
        <Dialog
          fullScreen
          open={this.state.bigImageDialogOpen}
          onClose={e => this.closeBigImageDialog()}
          color="inherit"
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={e => this.closeBigImageDialog()}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Button
                autoFocus
                color="inherit"
                onClick={e => this.closeBigImageDialog()}>
                <Typography variant="h6">
                  关闭
                </Typography>
              </Button>
            </Toolbar>
          </AppBar>

          <img src={this.state.bigImageUrl} alt={'' && 'item.title'} />
        </Dialog>

        <Dialog
          open={this.state.confirmDialogOpen}
          onClose={this.closeConfirmLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{width: '400px'}}>
            {`确认操作：${this.state.confirmShortTxt}？`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.state.confirmLongTxt || ''}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.state.doConfirmFunc()} color="secondary">
              {`确认${this.state.confirmShortTxt}`}
            </Button>
            <Button onClick={this.closeConfirmLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfRoomManagement= observer(TableOfRoomManagementInner);

TableOfRoomManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfRoomManagement);
